/** TB_BS_CODE GROUP_CD=WORK_TYPE 표준 코드 행 → 팝업 목록 */
export function MapStandardWorkTypeRows(codeRows) {
  return (codeRows || [])
    .filter((item) => item.groupCd === 'WORK_TYPE')
    .map((item) => ({
      code: item.code,
      codeNm: item.codeNm,
      ref1: item.ref1,
      isCust: false,
      isPrimary:
        String(item.ref1 ?? '').toUpperCase() === 'Y' ||
        ['일반작업', '화기작업'].includes(String(item.codeNm ?? '').trim()),
    }));
}

/** 사업장 커스텀 작업종류 API 응답 → 팝업 목록 (주 작업종 불가 — 보조만) */
export function MapCustWorkTypeRows(custRows) {
  return (custRows || []).map((row) => {
    const code = String(row.workType ?? row.WorkType ?? '').trim();
    const codeNm = String(row.workTypeNm ?? row.WorkTypeNm ?? '').trim();
    return {
      code,
      codeNm,
      ref1: 'N',
      isCust: true,
      isPrimary: false,
    };
  });
}

/** 표준 + 사업장 커스텀 병합 (코드 기준 중복 제거) */
export function MergeWorkTypeLists(standardRows, custRows) {
  const seen = new Set();
  const merged = [];
  for (const item of [...(standardRows || []), ...(custRows || [])]) {
    const code = String(item?.code ?? '').trim();
    if (!code || seen.has(code)) continue;
    seen.add(code);
    merged.push(item);
  }
  return merged.sort((a, b) =>
    String(a.codeNm ?? '').localeCompare(String(b.codeNm ?? ''), 'ko')
  );
}

export function BuildWorkTypeCodeMap(standardRows, custRows) {
  const map = {};
  MergeWorkTypeLists(standardRows, custRows).forEach((item) => {
    if (item.code) map[item.code] = item.codeNm || item.code;
  });
  return map;
}
